import { render, staticRenderFns } from "./PublicExamSummaryReport.vue?vue&type=template&id=b90a9a8c"
import script from "./PublicExamSummaryReport.vue?vue&type=script&lang=js"
export * from "./PublicExamSummaryReport.vue?vue&type=script&lang=js"
import style0 from "./PublicExamSummaryReport.vue?vue&type=style&index=0&id=b90a9a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports